import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';
import { EINGABE_HEADLINE_ID, tierartTitleId } from '../models/eingabeAnchors';
import { THH_POSITION } from '../models/tierPositions';

export const selectZurueckZumShopOpen = (state: IAppState): boolean =>
  state.transientState.zurueckZumShopModalOpen;

export const selectTakeOverRunning = (state: IAppState): boolean =>
  state.transientState.takeOverRunning;

export const selectEingabeTargetElementId = (state: IAppState): string | null => {
  const eingabeTarget = state.transientState.eingabeTarget;
  if (!eingabeTarget) {
    return null;
  }
  const { tiere, angebotsIds, positions } = state.tiergruppe;
  const titleOf = (cardId: string | undefined): string =>
    cardId === undefined ? EINGABE_HEADLINE_ID : tierartTitleId(cardId);
  switch (eingabeTarget.target) {
    case 'NEW_CARD':
      return titleOf(tiere[tiere.length - 1]?.cardId);
    case 'OFFER':
      if (eingabeTarget.appId === App.TKV_V2) {
        return titleOf(
          Object.keys(angebotsIds).find(cardId => angebotsIds[cardId] === eingabeTarget.angebotsId),
        );
      }
      return titleOf(positions[THH_POSITION[eingabeTarget.appId]]?.positionId);
    default:
      return EINGABE_HEADLINE_ID;
  }
};

export const selectJuristisch = (state: IAppState): boolean => state.transientState.juristisch;
